import {
  Box,
  Stack,
  Typography,
} from "@rentiohq/web-shared-next/dist/ui-components";
import { PaymentMethodOptionStyles } from "./PaymentMethodOption.styles";

export interface IProps {
  label: string;
  description: string;
  logos?: { icon: string; iconHeight?: number }[];
}

export const PaymentMethodOption = (props: IProps) => {
  const { label, description, logos = [] } = props;

  const sx = PaymentMethodOptionStyles();

  return (
    <Stack
      direction="row"
      gap={1}
      justifyContent="space-between"
      alignItems="center"
    >
      <Box>
        <Typography variant="h6" sx={sx.content.label}>
          {label}
        </Typography>
        <Typography variant="subtitle2" sx={sx.content.description}>
          {description}
        </Typography>
      </Box>
      {logos?.length > 0 && (
        <Stack
          direction="row"
          gap={2}
          justifyContent="space-between"
          alignItems="center"
        >
          {logos?.map(logo => {
            const { icon, iconHeight } = logo;
            return (
              <img
                src={icon}
                height={iconHeight || "14px"}
                alt="payment-method-icon"
              />
            );
          })}
        </Stack>
      )}
    </Stack>
  );
};
